import { cn } from "#utils";

export function ButtonBase({ children, color, className, ...props }) {
  return (
    <button
      type="button"
      {...props}
      className={cn(
        `rounded-sm bg-${color}-600 px-3 py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-${color}-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-${color}-600 dark:bg-${color}-500 dark:shadow-none dark:hover:bg-${color}-400 dark:focus-visible:outline-${color}-500`,
        className,
      )}
    >
      {children}
    </button>
  );
}
/*
 * Fix with making primary and secondary buttons and stuff
 * */
export function PrimaryButton({ children, ...props }) {
  return (
    <ButtonBase color="indigo" {...props}>
      {children}
    </ButtonBase>
  );
}
export function DangerButton({ children, ...props }) {
  return (
    <ButtonBase color="red" {...props}>
      {children}
    </ButtonBase>
  );
}
